<template>
  <v-card>
    <v-card-title>Instellingen afdelingendashboard</v-card-title>
    <v-card-subtitle>Profiel ....</v-card-subtitle>
    <v-card-text>
      <v-select
        v-model="afdeling"
        :items="afdelingen"
        return-object
        item-text="Naam"
        label="Afdeling"
      ></v-select>
      <v-checkbox v-for="(a,i) in afdelingen" :key="'a'+i.toString()" :label="a.Naam" dense>{{a.Naam}}</v-checkbox>
    </v-card-text>
    <v-card-actions>
      <v-btn>Ok</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "InstellingenAfdelingendashboard",
  data: () => ({ afdelingen: [], afdeling: null }),
  methods: {
    loadData: function () {
      this.$api.pAfdelingGetList().then((response) => {
        this.afdelingen = response.data;
      });
      this.$api
        .pProfielGet({ ProfielId: this.$route.params.id })
        .then((response) => {
          this.profiel = response.data[0];
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>